import { VideoTypeId, VideoTypes } from 'components/Contentful/VideoPlayer';
import { ReactElement } from 'react';
import { IFragmentRendiaVideo } from 'types/contentful';

type RendiaProps = { video: IFragmentRendiaVideo } & { url: URL };

export const isRendiaVideoGuard = (
  videoObject: VideoTypes
): videoObject is IFragmentRendiaVideo => {
  return (videoObject as IFragmentRendiaVideo).sys.contentType.sys.id === VideoTypeId.Rendia;
};

export default function Rendia(props: RendiaProps): ReactElement {
  const src = `//share.rendia.com/whitelabel/load/${btoa(props.url.toString())}/${
    props.video.fields.videoId
  }`;

  return (
    <iframe
      src={src}
      title="Rendia Embed Player"
      frameBorder="0"
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
      aria-label="Rendia Embed Player"
      onLoad={(evt) => ((evt.target as HTMLElement).style.visibility = 'visible')}
      scrolling="no"
    ></iframe>
  );
}
